/**
 * @license
 * @copyright Copyright Motili Inc., 2025 All Rights Reserved
 */
import { WorkOrder } from 'common/types';

export enum DASHBOARD_SCOPE {
    CLIENT = 'clientDashboard',
    CONTRACTOR = 'contractorDashboard',
}
export interface DashboardSectionRequest {
    id: string;
    params?: Record<string, any>;
}

export interface DashboardSectionResponse {
    id: string;
    result?: any;
    error?: any;
}

export interface DashboardClientResponse {
    id: string;
    name: string;
    doingBusinessAs: string;
}

export interface SectionState<T = any> {
    loading: boolean;
    error: any | null;
    data: T;
    params?: Record<string, any>;
}

export interface ScheduledDay {
    scheduleDate: string;
    workOrders: WorkOrder[];
    isToday: boolean;
}

export enum SECTION_ID {
    contractorCoverageArea = 'contractorCoverageArea',
    contractorTeamMembers = 'contractorTeamMembers',
    scheduledWorkOrders = 'scheduledWorkOrders',
    needAttentionWorkOrders = 'needAttentionWorkOrders',
    openOrders = 'openOrders',
    orderDetails = 'orderDetails',
    monthlySpending = 'monthlySpending',
}

export enum DASHBOARD_TYPES {
    WORK_ORDER = 'WORK_ORDER',
    ORDER = 'ORDER',
}

export const dashboardTypes = {
    WORK_ORDER: {
        id: DASHBOARD_TYPES.WORK_ORDER,
        display: 'Work Order',
    },
    ORDER: {
        id: DASHBOARD_TYPES.ORDER,
        display: 'Order',
    },
};
